module.exports = "/_next/static/images/features-compliance-c0927248a68bc88ab2b70c47109d56ad.png";